import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addDoc,
  getFirestore,
  collection,
  serverTimestamp,
} from "firebase/firestore";

export const saveBooking = createAsyncThunk(
  "bookings/saveBooking",
  async (bookingDetails, { rejectWithValue }) => {
    try {
      console.log("Inside saveBooking:", bookingDetails);
      const db = getFirestore();
      const bookingsCollectionRef = collection(db, "bookings");
      const payload = {
        ...bookingDetails,
        createdAt: serverTimestamp(),
      };
      const docRef = await addDoc(bookingsCollectionRef, payload);
      console.log("Document written with ID: ", docRef.id);
      return {
        id: docRef.id,
        ...bookingDetails,
      };
    } catch (error) {
      console.error("Error saving booking:", error);
      return rejectWithValue(error.message);
    }
  }
);
